export const BuyingRecommendationActionTypes = {
  SET_SUGGESTED_DATA: "SET_SUGGESTED_DATA",
  SET_DIRECT_FACTORY_SUGGESTED_DATA: "SET_DIRECT_FACTORY_SUGGESTED_DATA",
  SET_RAKE_SUGGESTED_DATA: "SET_RAKE_SUGGESTED_DATA",
  ADD_SUGGESTED_DATA: "ADD_SUGGESTED_DATA",
  SET_ABD_SUGGESTED_DATA: "SET_ABD_SUGGESTED_DATA",
  SET_SUGGESTED_HUB_DATA: "SET_SUGGESTED_HUB_DATA",
  SET_OVERALL_HUB_DATA: "SET_OVERALL_HUB_DATA",
  SET_ABD_SOH_DATA: "SET_ABD_SOH_DATA",
};
